<template>
  <v-container>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
  Notification Templates

  <div class="d-flex align-center">
    <span class="mr-2">Notifications</span>
    <v-switch
      v-model="isNotificationEnabled"
      @change="toggleNotifications"
      inset
      color="primary"
      :loading="toggleLoading"
    ></v-switch>

    <v-btn color="primary" class="ml-4" @click="$router.push('/templatecreatefortimenotification')">
      Create New
    </v-btn>
  </div>
</v-card-title>

      <v-data-table
        :headers="headers"
        :items="templates"
        :loading="loading"
        class="elevation-1"
        loading-text="Loading templates..."
      >
        <template v-slot:item.message="{ item }">
          <div class="text-truncate" style="max-width: 400px;">{{ item.message }}</div>
        </template>

        <template v-slot:item.scheduled_time="{ item }">
          {{ formatTime(item.scheduled_time) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="blue" @click="openEditDialog(item)">mdi-pencil</v-icon>
          <v-icon small class="mr-2" color="red" @click="confirmDelete(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snackbar" color="success">{{ snackbarText }}</v-snackbar>

    <!-- Edit Modal -->
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>Edit Template</v-card-title>
        <v-card-text>
          <v-textarea label="Message" v-model="editForm.message"></v-textarea>
          <v-text-field label="Scheduled Time (HH:mm)" v-model="editForm.scheduled_time"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="updateTemplate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

  
  <script>
import axios from 'axios';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      loading: false,
      snackbar: false,
      snackbarText: '',
      templates: [],
      editDialog: false,
      toggleLoading: false, // <-- Add this here
      isNotificationEnabled: false, // <-- And this for the toggle switch
      editForm: {
        time_notification_id: null,
        message: '',
        scheduled_time: '',
      },
      headers: [
        { text: 'Message Template', value: 'message', sortable: false },
        { text: 'Scheduled Time', value: 'scheduled_time' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  created() {
    this.fetchTemplates();
    this.fetchNotificationStatus();
  },
  methods: {
    async toggleNotifications() {
  try {
    this.toggleLoading = true;
    const schoolId = localStorage.getItem('user_id');

    const response = await axios.post('/timenotification/toggleNotification', {
      school_id: schoolId,
      is_notification: this.isNotificationEnabled,
    });

    if (response.data.status) {
      this.snackbarText = this.isNotificationEnabled
        ? 'Notifications turned ON'
        : 'Notifications turned OFF';
      this.snackbar = true;
    } else {
      this.snackbarText = 'Failed to update notifications.';
      this.snackbar = true;
    }
  } catch (error) {
    console.error('Toggle error:', error);
    this.snackbarText = 'Something went wrong while toggling.';
    this.snackbar = true;
  } finally {
    this.toggleLoading = false;
  }
},

    async fetchTemplates() {
      this.loading = true;
      try {
        const schoolId = localStorage.getItem('user_id');
        const response = await axios.get('/timenotification/getAllTimeNotifications', {
          params: { school_id: schoolId },
        });
        this.templates = response.data.data;
      } catch (error) {
        console.error('Error fetching templates:', error);
      } finally {
        this.loading = false;
      }
    },

    formatTime(time) {
      return time ? dayjs(`2000-01-01T${time}`).format('hh:mm A') : '';
    },

    formatDateTime(datetime) {
      return datetime ? dayjs(datetime).format('DD/MM/YYYY HH:mm') : '';
    },

    async confirmDelete(item) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'This will permanently delete the template.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
      });

      if (result.isConfirmed) {
        this.deleteTemplate(item);
      }
    },

    async deleteTemplate(item) {
      try {
        const response = await axios.delete(`/timenotification/deleteTimeNotification`, {
          params: { time_notification_id: item.id },
        });
        if (response.data.status) {
          this.snackbarText = 'Template deleted successfully!';
          this.snackbar = true;
          this.fetchTemplates();
        } else {
          this.snackbarText = 'Failed to delete template.';
          this.snackbar = true;
        }
      } catch (error) {
        console.error('Error deleting template:', error);
        this.snackbarText = 'An error occurred while deleting.';
        this.snackbar = true;
      }
    },

    openEditDialog(item) {
      this.editForm = { ...item }; // populate form
      this.editDialog = true;
    },

    async updateTemplate() {
      try {
        const formattedTime = dayjs(`2000-01-01T${this.editForm.scheduled_time}`).format('HH:mm');
     
    const payload = {
      ...this.editForm,
      time_notification_id: this.editForm.id,
      scheduled_time: formattedTime,
    };
        const response = await axios.post('/timenotification/updateTimeNotification', payload);
        if (response.data.status) {
          this.snackbarText = 'Template updated successfully!';
          this.snackbar = true;
          this.fetchTemplates();
          this.editDialog = false;
        } else {
          this.snackbarText = 'Failed to update template.';
          this.snackbar = true;
        }
      } catch (error) {
        console.error('Error updating template:', error);
        this.snackbarText = 'An error occurred while updating.';
        this.snackbar = true;
      }
    },
    async fetchNotificationStatus() {
  try {
    const schoolId = localStorage.getItem('user_id');
    const res = await axios.get('/timenotification/getNotificationStatus', {
      params: { school_id: schoolId },
    });
   if(res.data.status) {  
     this.isNotificationEnabled = res.data.data.is_enabled;

   }
  } catch (e) {
    console.error('Fetch toggle state error:', e);
  }
},

  },
};

  </script>
  
  <style scoped>
  .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  </style>
  